import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { currentUser, tenantData } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/signin" />;
  }

  if (!tenantData) {
    return <Navigate to="/pricing" />;
  }

  return <>{children}</>;
};

export default PrivateRoute; 